import './footer.scss'

/* React */
import { useCallback } from 'react'

/* Context */
import { useContext } from 'react'
import { AppContext } from 'src/AppContext'

/* Bootstrap */
import Navbar from 'react-bootstrap/Navbar'
import Nav from 'react-bootstrap/Nav'

/* FontAwesome */
import { FontAwesomeIcon as FontAwesome } from '@fortawesome/react-fontawesome'
import { faUser } from '@fortawesome/free-solid-svg-icons'

/* Components */
import ThemeSwitch from './ThemeSwitch'

const Footer:React.FC = () => {
  const { appState:{user}, appDispatch } = useContext(AppContext)

  const handleLogout = useCallback(() => {
    localStorage.removeItem('User')
    appDispatch({type: 'LOGOUT'})
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <footer className="App-footer" data-testid='App-Footer'>

    <Navbar bg='dark' variant='dark' expand='md'>

      <Nav navbar className='left'>
        <Nav.Link onClick={handleLogout} role='button'>
          <FontAwesome icon={faUser} /> {user?.name || 'Logout'}
        </Nav.Link>
      </Nav>

      <Nav navbar className='right'>

        <ThemeSwitch />

        <Nav.Link href={`/#/hilfe`}>
          Hilfe
        </Nav.Link>
        
      </Nav>

    </Navbar>
    
  </footer>
}

export default Footer